import { render, staticRenderFns } from "./PriceIndex.vue?vue&type=template&id=28d0a508&scoped=true&"
import script from "./PriceIndex.vue?vue&type=script&lang=js&"
export * from "./PriceIndex.vue?vue&type=script&lang=js&"
import style0 from "./PriceIndex.vue?vue&type=style&index=0&id=28d0a508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0a508",
  null
  
)

export default component.exports